/**
 * Validates email format using regex pattern
 * Returns true if email is valid, false otherwise
 *
 * Valid email format: local@domain.tld
 * - Must have local part before @
 * - Must have @ symbol
 * - Must have domain part after @
 * - Must have top-level domain (TLD) after dot
 */
export const validateEmail = (email: string): boolean => {
  // Standard email regex pattern
  // Matches: local@domain.tld
  // Does not match: empty strings, strings without @, strings without domain, invalid characters
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
